<div [hidden]="!loading" class="page-loader text-center">
  <div class="loader"></div>
</div>

@if (post$ | async; as post) {
  <div class="container">
    <ul class="breadcrumbs">
      <li>
        <a [core-analytics]="{ action: 'Home', category: 'POST' }" routerLink="/">Home</a>
      </li>
      <li>
        <a [core-analytics]="{ action: 'Articles', category: 'POST' }" routerLink="/articles">Articles</a>
      </li>
      <li [innerText]="post.name"></li>
    </ul>
    <h1 [innerText]="post.name" class="post-h1"></h1>
    <div class="lead">
      <p [innerHTML]="post.description"></p>
    </div>
    <div class="content-section">
      <div [innerHTML]="post.content"></div>
    </div>
  </div>
}
